import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchFromStrapi } from "../api/strapi";
import "../CaseStudyPdf.css";

export default function CaseStudyPDF() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [caseStudy, setCaseStudy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCaseStudy() {
      try {
        const res = await fetchFromStrapi(`/ecl-case-study-sections/${id}`);
        setCaseStudy(res?.data?.data || res?.data);
      } catch (err) {
        console.error("Error fetching case study:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchCaseStudy();
  }, [id]);

  if (loading) {
    return (
      <div className="pdf-loading-state">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!caseStudy) {
    return (
      <div className="container py-5 text-center">
        <h3>Case study not found</h3>
        <button
          onClick={() => navigate("/caseStudies")}
          className="btn btn-dark mt-3"
        >
          Back to Case Studies
        </button>
      </div>
    );
  }

  const pdfUrl = caseStudy?.attributes?.attachment?.data?.attributes?.url;

  return (
    <div className="pdf-viewer-page">

      {/* Header bar */}
      <div className="pdf-viewer-bar">
        <button
          onClick={() => navigate("/caseStudies")}
          className="btn btn-outline-dark btn-sm"
        >
          Back
        </button>

        <h6 className="pdf-viewer-title mb-0">
          {caseStudy.attributes.Title}
        </h6>

        {pdfUrl && (
          <a href={pdfUrl} download className="btn btn-dark btn-sm">
            <i className="bi bi-download me-2" />
            Download
          </a>
        )}
      </div>

      {/* PDF — rendered by the browser's native viewer */}
      {pdfUrl ? (
        <iframe
          src={pdfUrl}
          title={caseStudy.attributes.Title}
          className="pdf-iframe"
        />
      ) : (
        <div className="container py-5 text-center">
          <p className="text-muted">No PDF is attached to this case study.</p>
        </div>
      )}

    </div>
  );
}
